﻿import { resp } from "../objects/ttc/payment_response/resp";
import { return_status } from "../objects/v1_3/return_status";

import { payment_profile, request } from "../objects/v1_3/payment/initialise/request";
import { request_payment } from "../objects/v1_3/payment/initialise/request_payment";
import { request_payment_url } from "../objects/v1_3/payment/initialise/request_payment_url";
import { request_payment_token } from "../objects/v1_3/payment/initialise/request_payment_token";
import { response } from "../objects/v1_3/payment/initialise/response";
import { response_method } from "../objects/v1_3/payment/initialise/response_method";

import { response_login } from "../objects/agent/identity/v1_3/response_login";

import { booking_search_group } from "../objects/v1_2/Booking_Details/booking_search_group";

import { Security } from "./security";
import { Rest_API } from "../../system/services/rest_api";
import { booking } from "../objects/v1_2/Booking_Put/booking";
import { client_booking } from "../objects/v1_2/Booking_Details/client_booking";
import { trip_passenger } from "../objects/v1_2/Booking/Trip_Passenger";
import { request_payment_initialise_internal } from "../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import payment from "../components/consumer/payment";

export class Payment {

    Rest: Rest_API = new Rest_API();
    Secure: Security = new Security();

    public async Payment_Available_Providers_And_Methods(app_id: string, iso_currency_code: string) : Promise<response_method[]> {
        return this.Rest.Get_Data_Secure<response_method[]>(import.meta.env.VITE_PAYMENT_URL + "/api/v1.3/" + app_id + "/payment/providers/" + iso_currency_code, await this.determine_app_hash_password(app_id));
    }
    public async Payment_Initialise(full_payment: boolean,
         deposit: boolean,
         booking_info: booking_search_group,
         payment_session : request_payment_initialise_internal | null, 
         agent_response_login: response_login, 
         consumer_sale: boolean, 
         nett_sale: boolean, 
         app_id: string,
         selected_provider: string | null = null,
         selected_methods: string[] | null = null,
         selected_payment_profile: payment_profile | null = null) {

        let Payment_Request: request = new request();
        let payment_urls: request_payment_url = new request_payment_url();
        
        if(import.meta.env.VITE_DEFAULT_URL_SUCCESS != "" && import.meta.env.VITE_DEFAULT_URL_SUCCESS != undefined && import.meta.env.VITE_DEFAULT_URL_SUCCESS != null)
            payment_urls.url_success = import.meta.env.VITE_DEFAULT_URL_SUCCESS;
        if(import.meta.env.VITE_DEFAULT_URL_CANCELLATION != "" && import.meta.env.VITE_DEFAULT_URL_CANCELLATION != undefined && import.meta.env.VITE_DEFAULT_URL_CANCELLATION != null)
            payment_urls.url_cancellation = import.meta.env.VITE_DEFAULT_URL_CANCELLATION;
        if(import.meta.env.VITE_DEFAULT_URL_FAILURE != "" && import.meta.env.VITE_DEFAULT_URL_FAILURE != undefined && import.meta.env.VITE_DEFAULT_URL_FAILURE != null)
            payment_urls.url_failure = import.meta.env.VITE_DEFAULT_URL_FAILURE;

        Payment_Request.payment_provider = selected_provider;
        Payment_Request.payment_methods = selected_methods ?? [];
        Payment_Request.booking_id = booking_info.group_booking_id;
        Payment_Request.iso_currency_code = booking_info.trips[0].iso_currency_code;
        Payment_Request.full_payment = full_payment;
        Payment_Request.deposit = deposit;
        Payment_Request.online_sale = consumer_sale;
        Payment_Request.nett_sale = nett_sale;
        if (agent_response_login?.token?.access_token != null) {
            Payment_Request.token = agent_response_login?.token
        } else if (payment_session?.payment_initialise?.token?.access_token != null) {
            Payment_Request.token = payment_session?.payment_initialise?.token;
        } 
        Payment_Request.payment_urls = payment_urls;
        Payment_Request.payment_profile = selected_payment_profile ?? payment_profile.Default;
        Payment_Request.payments = this.get_Payments(nett_sale, full_payment, deposit, booking_info, payment_session, consumer_sale);
        sessionStorage.setItem("booking_id", booking_info.group_booking_id.toString());

        if (import.meta.env.VITE_ENABLE_CONSOLE_LOGGING == "true") {
            console.log(JSON.stringify(Payment_Request));
        }

        return this.Rest.Post_Data_Secure<request, response>(import.meta.env.VITE_PAYMENT_URL + "/api/v1.3/" + app_id + "/payment/initialise", await this.determine_app_hash_password(app_id), Payment_Request);
    }
    public async Payment_Initialise_Custom_URLS(full_payment: boolean, deposit: boolean, booking_info: booking_search_group, payment_session : request_payment_initialise_internal, agent_response_login: response_login, consumer_sale: boolean, nett_sale: boolean, app_id: string, custom_urls: request_payment_url) {

        let Payment_Request: request = new request();
        let payment_urls: request_payment_url = new request_payment_url();
        
        if(custom_urls.url_success != "" && custom_urls.url_success != undefined && custom_urls.url_success != null)
            payment_urls.url_success = custom_urls.url_success;
        if(custom_urls.url_cancellation != "" && custom_urls.url_cancellation != undefined && custom_urls.url_cancellation != null)
            payment_urls.url_cancellation = custom_urls.url_cancellation;
        if(custom_urls.url_failure != "" && custom_urls.url_failure != undefined && custom_urls.url_failure != null)
            payment_urls.url_failure = custom_urls.url_failure;

        Payment_Request.booking_id = booking_info.group_booking_id;
        Payment_Request.iso_currency_code = booking_info.trips[0].iso_currency_code;
        Payment_Request.full_payment = full_payment;
        Payment_Request.deposit = deposit;
        Payment_Request.online_sale = consumer_sale;
        Payment_Request.nett_sale = nett_sale;
        if (agent_response_login?.token?.access_token != null) {
            Payment_Request.token = agent_response_login?.token
        } else if (payment_session?.payment_initialise?.token?.access_token != null) {
            Payment_Request.token = payment_session?.payment_initialise?.token;
        } 
        Payment_Request.payment_urls = payment_urls;
        Payment_Request.payments = this.get_Payments(nett_sale, full_payment, deposit, booking_info, payment_session, consumer_sale);
        sessionStorage.setItem("booking_id", booking_info.group_booking_id.toString());

        if (import.meta.env.VITE_ENABLE_CONSOLE_LOGGING == "true") {
            console.log(JSON.stringify(Payment_Request));
        }

        return this.Rest.Post_Data_Secure<request, response>(import.meta.env.VITE_PAYMENT_URL + "/api/v1.3/" + app_id + "/payment/initialise", await this.determine_app_hash_password(app_id), Payment_Request);
    }
    public async Payment_Capture(full_payment: boolean,
        deposit: boolean,
        booking_info: booking_search_group,
        paypal_payment_initialise : response | null, 
        agent_response_login: response_login, 
        consumer_sale: boolean, 
        nett_sale: boolean, 
        app_id: string,
        selected_provider: string | null = null,
        payment_order_id: string) {

        let Payment_Request: request = new request();
        let payment_urls: request_payment_url = new request_payment_url();
        
        if(import.meta.env.VITE_DEFAULT_URL_SUCCESS != "" && import.meta.env.VITE_DEFAULT_URL_SUCCESS != undefined && import.meta.env.VITE_DEFAULT_URL_SUCCESS != null)
            payment_urls.url_success = import.meta.env.VITE_DEFAULT_URL_SUCCESS;
        if(import.meta.env.VITE_DEFAULT_URL_CANCELLATION != "" && import.meta.env.VITE_DEFAULT_URL_CANCELLATION != undefined && import.meta.env.VITE_DEFAULT_URL_CANCELLATION != null)
            payment_urls.url_cancellation = import.meta.env.VITE_DEFAULT_URL_CANCELLATION;
        if(import.meta.env.VITE_DEFAULT_URL_FAILURE != "" && import.meta.env.VITE_DEFAULT_URL_FAILURE != undefined && import.meta.env.VITE_DEFAULT_URL_FAILURE != null)
            payment_urls.url_failure = import.meta.env.VITE_DEFAULT_URL_FAILURE;

        Payment_Request.payment_provider = selected_provider;
        Payment_Request.booking_id = booking_info.group_booking_id;
        Payment_Request.iso_currency_code = booking_info.trips[0].iso_currency_code;
        Payment_Request.full_payment = full_payment;
        Payment_Request.deposit = deposit;
        Payment_Request.online_sale = consumer_sale;
        Payment_Request.nett_sale = nett_sale;
        if (agent_response_login?.token?.access_token != null) {
            Payment_Request.token = agent_response_login?.token
        // } else if (payment_session?.payment_initialise?.token?.access_token != null) {
        //     Payment_Request.token = payment_session?.payment_initialise?.token;
        } 
        Payment_Request.payment_urls = payment_urls;
        Payment_Request.payments = this.get_Payments(nett_sale, full_payment, deposit, booking_info, null, consumer_sale);
        sessionStorage.setItem("booking_id", booking_info.group_booking_id.toString());

        //console.log(JSON.stringify(Payment_Request));

        return this.Rest.Post_Data_Secure<request, return_status>(import.meta.env.VITE_PAYMENT_URL + "/api/v1.3/" + app_id + "/payment/capture/" + payment_order_id, await this.determine_app_hash_password(app_id), Payment_Request);
    }
    public async determine_app_hash_password(app_id: string) {
        let hash_password : string = "";
        if (app_id == import.meta.env.VITE_APP_ID_TOR) 
        {
            hash_password = await this.Secure.Get_Hash_Password_For_APP_ID(app_id, this.get_api_key(app_id));
        }
        else if (app_id == import.meta.env.VITE_APP_ID_AUS) 
        {
            hash_password = await this.Secure.Get_Hash_Password_For_APP_ID(app_id, this.get_api_key(app_id));
        }
        else 
        {
            hash_password = await this.Secure.Get_Hash_Password();
        }
        return hash_password;
    }
    public async Get_Payment_Session(store: any, session_id: string, method:string | null, app_id: string) : Promise<request_payment_initialise_internal>  {
        let hash_password : string = await this.Secure.Get_Hash_Password_Payment_API();
        var url = import.meta.env.VITE_PAYMENT_URL + "/api/v1.3/" + app_id + "/payment/session/" + session_id;
        
        if (method != null && method != undefined && method != "") {
            url = url + "/" +  method;
        }
        
        const result = await this.Rest.Get_Data_Secure<request_payment_initialise_internal>(url, hash_password).then(response => {
            return response.json();
        });            

        result.provider_name = method;
        store.commit("Payment_Session", { request_payment_initialise_internal: result });

        return result;
    }
    public get_api_key(app_id: string): string {
        let api_key : string = "";
        if (app_id == import.meta.env.VITE_APP_ID_TOR) {
            api_key = import.meta.env.VITE_API_KEY_TOR;
        }
        else if (app_id == import.meta.env.VITE_APP_ID_AUS) {
            api_key = import.meta.env.VITE_API_KEY_AUS;
        }
        else 
        {
            api_key = import.meta.env.VITE_PAYMENT_API_KEY;
        }
        return api_key;
    }
    public get_Payments(nett_sale: boolean, full_payment: boolean, deposit: boolean, booking_info: booking_search_group, payment_session : request_payment_initialise_internal, consumer_sale: boolean): request_payment[] {
        let Output_Payments: request_payment[] = [];

        if (payment_session != undefined && payment_session != null && payment_session.payment_initialise.payments != null && payment_session.payment_initialise.payments.length > 0) {
            payment_session.payment_initialise.payments.forEach( payment => {
                Output_Payments.push(payment);
            });
        }
        else {
            booking_info.trips.forEach(trip => {
                trip.passengers.forEach(trip_passenger => {
                    if (trip_passenger.outstanding > 0) {
                        if (full_payment == true) {
                            Output_Payments.push(this.get_Full_Payment_Item(nett_sale, trip_passenger, consumer_sale));
                        }

                        if (deposit == true) {
                            Output_Payments.push(this.get_Deposit_Payment_Item(nett_sale, trip_passenger));
                        }
                    }
                });
            });
        }

        return Output_Payments;
    }
    private get_Part_Payment_Item(nett_sale: boolean, trip_passenger: client_booking): request_payment {
        let Output_Payment: request_payment = new request_payment();
        Output_Payment.client_booking_id = trip_passenger.trip_passenger_identifier;

        if (nett_sale == true && (trip_passenger.commission ?? 0) != 0) {
            Output_Payment.commission = trip_passenger.commission;
            Output_Payment.amount = trip_passenger.outstanding - trip_passenger.commission;
        } else {
            if ((trip_passenger.commission ?? 0) > 0) {
                Output_Payment.commission = trip_passenger.commission;
            }
            Output_Payment.amount = trip_passenger.outstanding;
        }

        return Output_Payment;
    }
    private get_Full_Payment_Item(nett_sale: boolean, trip_passenger: client_booking, consumer_sale: boolean): request_payment {
        let Output_Payment: request_payment = new request_payment();
        Output_Payment.client_booking_id = trip_passenger.trip_passenger_identifier;

        if (nett_sale == true && (trip_passenger.commission ?? 0) != 0) {
            Output_Payment.amount = trip_passenger.outstanding - trip_passenger.commission;
            Output_Payment.commission = trip_passenger.commission;
            Output_Payment.gross_amount = trip_passenger.outstanding;
        } else {
            if ((trip_passenger.commission ?? 0) > 0) {
                if (import.meta.env.VITE_PAYMENT_GROSS_SEND_AMOUNT) { //if not passing this for RTG Agent Portal it generates an error
                    Output_Payment.amount = trip_passenger.outstanding; // - trip_passenger.commission;
                }            
                Output_Payment.commission = trip_passenger.commission;
                Output_Payment.gross_amount = trip_passenger.outstanding;
            } 
            else {
                Output_Payment.amount = trip_passenger.outstanding;
                //if (consumer_sale == true) {
                    Output_Payment.gross_amount = trip_passenger.outstanding;
                //}
            }
        }

        return Output_Payment;
    }
    private get_Deposit_Payment_Item(nett_sale: boolean, trip_passenger: client_booking): request_payment {
        let Output_Payment: request_payment = new request_payment();
        Output_Payment.client_booking_id = trip_passenger.trip_passenger_identifier;
        Output_Payment.amount = trip_passenger.deposit;
        if (trip_passenger.deposit == trip_passenger.outstanding) {
            Output_Payment.commission = trip_passenger.commission;
            Output_Payment.gross_amount = trip_passenger.outstanding;
        } 
        else if(trip_passenger.deposit <= trip_passenger.outstanding) {
            Output_Payment.gross_amount = trip_passenger.deposit;
        }
        

        return Output_Payment;
    }
    public get_payment_providerandmethod(Response: response, payment_method: string): response_method {
        let Response_Method: response_method = new response_method();
        //no support for payment_link methods yet in the booking engine so just look for method and processor with same value
        Response.payment_methods.forEach(method => {
            if (method.payment_processor?.toLowerCase() == payment_method.toLowerCase() 
                && method.payment_method?.toLowerCase() == payment_method.toLowerCase()) {
                Response_Method = method;
            }
        });

        return Response_Method;
    }
    public get_payment_reference(Response: response): string {
        let return_reference: string = "";
        Response.payment_methods.forEach(method => {
            return_reference = method.payment_reference ?? "";
            return;
        });

        return return_reference;
    }
    public async Commit_Payment_TTC_Payment_Gateway(Payment: resp, app_id: string): Promise<return_status> {
        return this.Rest.Post_Data<resp, return_status>(import.meta.env.VITE_PAYMENT_TTC_URL + "/api/v1.3/" + app_id + "/payment/response", Payment).then(response => { return response.json(); });
    }
    public has_part_payment_amount(payment_session: request_payment_initialise_internal): number {
        let Total_Amount: number = 0;

        payment_session?.payment_initialise.payments.forEach(function (payment) {
            Total_Amount += payment.amount ?? 0;
        });
        return Total_Amount;
    }
    public get_part_payment_total(payment_session: request_payment_initialise_internal): number {
        let Total_Amount: number = 0;
        var isNett = payment_session?.payment_initialise?.nett_sale;

        payment_session?.payment_initialise.payments.forEach(function (payment) {
            if (isNett) {
                Total_Amount += payment.amount ?? 0;
            } 
            else {
                Total_Amount += payment.amount ?? 0; //gross_amount
            }
        });
        return Total_Amount;
    }
    public get_total_outstanding(payment_session: request_payment_initialise_internal): number {
        let Total_Amount: number = 0;
        var isNett = payment_session?.payment_initialise?.nett_sale;

        payment_session?.payment_initialise.payments.forEach(function (payment) {
            if (isNett) {
                Total_Amount += payment.amount ?? 0;
            } 
            else {
                Total_Amount += payment.gross_amount ?? payment.amount ?? 0;
            }
        });

        // payment_session?.get_booking.trips?.forEach(function (trip) {
        //     trip?.passengers?.forEach(function (passenger) {
        //         if (isNett) {
        //             Total_Amount += passenger.outstanding_nett ?? 0;
        //         } 
        //         else {
        //             Total_Amount += passenger.outstanding ?? 0;
        //         }
        //     });
        // });

        return Total_Amount;
    }
    public get_Total_Deposit(payment_session: request_payment_initialise_internal): number {
        let Total_Amount: number = 0;
        var isNett = payment_session?.payment_initialise?.nett_sale;

        payment_session?.get_booking?.trips?.forEach(function (trip) {
            trip?.passengers?.forEach(function (passenger) {
                if (isNett) {
                    Total_Amount += passenger.deposit_nett ?? 0;
                } 
                else {
                    Total_Amount += passenger.deposit ?? 0;
                }
            });
        });

        return Total_Amount;
    }
    public toCurrency(num: number) : number {
        if (num == null) return 0;

        let places : number = 2;
        const factor = 10 ** places;
        return Math.round(num * factor) / factor;
    }
    public AddCurrency(num1: number | null, num2: number | null) : number | null {
        //function to workaround know JS issues when adding decimals: https://www.cgrimes.dev/how-to-make-decimals-correctly-add-up/
        if (num1 == null) return num2;
        if (num2 == null) return num1;
        
        let places : number = 2;
        const factor = 10 ** places;
        return Math.round((num1 * factor) + (num2 * factor)) / factor;
    }

}